import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileNameTransform',
  standalone: false
})
export class FileNameTransformPipe implements PipeTransform {
  public transform(currentData: any) {
    let finalValue = '';
    if (currentData == null || '')
      return finalValue;

    let extensionSplit = currentData.split('.');
    let extension = extensionSplit[extensionSplit.length - 1];
    extensionSplit.splice(extensionSplit.length - 1, 1);

    if (extensionSplit.length > 0) {
      let fileName = extensionSplit.join('.');

      let fileNameSplit = fileName.split('_');

      if (fileNameSplit.length > 1) {
        fileNameSplit.splice(fileNameSplit.length - 1, 1);
        finalValue = fileNameSplit.join('_') + '.' + extension;
      }
      else {
        finalValue = currentData;
      }
    }
    return finalValue;
  }
}
